export const quitAppAction = async () => {
    if (!window.electronApi) {
        return;
    }

    window.electronApi.quitApp();
};
